































































  import { Component, mixins, namespace } from 'nuxt-property-decorator';
import SPage from "../components/page/SPage.vue";
import DialogLoading from "~/components/common/DialogLoading.vue";
import {
  WishlistMixin,
  CategoryMixin,
  CmsMetaMixin,
  CartMixin
} from "~/node_modules/sitis-nuxt/lib/mixins";
import ProductCard from "~/components/product/ProductCard.vue";
import { IAddItemToCartBody } from 'sitis-nuxt/lib/store/modules/cart-store';

import { namespace as cartStore } from '~/node_modules/sitis-nuxt/lib/store/modules/cart-store';
import { actionType as cartActionType } from '~/node_modules/sitis-nuxt/lib/store/modules/cart-store';

const CartStore = namespace(cartStore);

@Component({
  components: {
    SPage,
    ProductCard,
    DialogLoading
  },

  data: function() {
    return {
      pageBreadcrumbs: [
        { title: "Главная", path: "/" },
        { title: "Избранное", path: "/wishlist" },
      ]
    }
  },

  async mounted (this: WishlistPage) {
    await this.getWishlist();
  }
})

export default class WishlistPage extends mixins(
  WishlistMixin,
  CategoryMixin,
  CmsMetaMixin
) {

  isOpenDialogLoading: boolean = false;

  onClearWishlist(): void {
    if (window.confirm("Очистить избранное?")) {
      this.clearWishlist();
    }
  }

  get visibleButtonBuy () {
    return Boolean(process.env.ENVIRONMENT !== 'production')
  }

  async buyAllProducts () {
    this.isOpenDialogLoading = true;

    const isSuccess = await this.$api.agent.transport.post('wishlist/move-to-cart').then((res: any) => {
      return true
    }).catch((err: any) => {
      return false
    });

    await this.getCart();

    this.isOpenDialogLoading = false;

    this.$toast.success("Товары успешно добавлены в корзину");
  }


  @CartStore.Action(cartActionType.GET_CART)
  readonly getCart!: () => Promise<boolean>;
}
